/** Сколько ждать простоя, прежде чем выполнить всё равно. */
const IDLE_TIMEOUT_MS = 5000;

/**
 * Выполнить, когда у страницы простой: фоновая работа после старта (прогрев, телеметрия) не должна
 * делить кадры с первым экраном. Где `requestIdleCallback` нет (старый WebView, Safari) - на
 * следующем такте.
 */
export const whenIdle = (fn: () => void): void => {
  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(fn, { timeout: IDLE_TIMEOUT_MS });
  } else {
    setTimeout(fn, 0);
  }
};
